module.exports = __webpack_public_path__ + "assets/img/bgh.7e6bff5b.jpg";